export default {
  '{} catches logged here': '{} capturas registradas aquí',
  '{} likes': '{} likes',
  '{} markers': '{} más',
  '{} overlapping area': '{} área superpuesta',
  '{} overlapping areas': '{} áreas superpuestas',
  '{} places sharing location': '{} lugares compartiendo la misma ubicación',
  '{days} day ago': 'Hace {days} dìa',
  '{days} days ago': 'Hace {days} dìas',
  '{hours} hour ago': 'Hace {hours} hora',
  '{hours} hours ago': 'Hace {hours} horas',
  '{mins} min ago': 'Hace {mins} min',
  '{month} {date}': '{month} de {date}',
  '{month} {date}, {year}': '{month} de {date} de {year}',
  '* Required field': '* Campo requerido',
  '-- Select type --': '-- Seleccione tipo --',
  About: 'Acerca de',
  'Add Point of Interest': 'Agregar punto de interés',
  'Add this map to your website': 'Agregue este mapa a su sitio web',
  'Add to the map': 'Agregar al mapa',
  Address: 'Dirección',
  'Also present': 'También presente',
  'Alternative 1': 'Alternativa 1',
  'Alternative 2': 'Alternativa 2',
  'Anglers showing their catches in this area.': 'Pescadores mostrando sus capturas en esta área',
  'Any area of the marine environment that has been reserved by Federal, State, local or other laws or regulations for the purpose of maintaining or enhancing the lasting conservation of its natural resources.':
    'Cualquier área del medio marino que haya sido reservada por leyes o regulaciones federales, estatales, locales u otras con el propósito de mantener o mejorar la conservación de sus recursos naturales.',
  'Available for iOS and Android': 'Disponible para dispositivos iOS y Android',
  'Bait Shop': 'Tienda de Carnada',
  'Be the first one to like on Fishbrain': 'Sé el primero en dar like en Fishbrain',
  'Be the first one to log a catch here on': 'Sé el primero en registrar una captura aquí en',
  'Boat Ramp': 'Rampa para botes',
  'Catch Ease': 'Facilidad de Captura',
  'Caught species on Fishbrain': 'Especies capturadas en Fishbrain',
  Charter: 'Alquiler de Botes',
  City: 'Ciudad',
  'Company Name': 'Nombre de la compañía',
  'Connect with anglers and discover what is happening on the waters nearby, right now.':
    'Conéctate con otros pescadores y descubre lo que está sucediendo en otros lugares cercanos ahora.',
  Contact: 'Contacto',
  County: 'Condado',
  Description: 'Descripción',
  'Download the Fishbrain app': 'Descargue la aplicación de Fishbrain',
  'Email this information with subject and additional information to rbffmapalert@rbff.org.':
    'Envíe esta información por correo electrónico a rbffmapalert@rbff.org.',
  Email: 'Correo electrónico',
  'Email:': 'Email:',
  'Enter your phone number...': 'Ingresa tu número de telefóno...',
  'Explore entire U.S.': 'Explore todo U.S.',
  'Explore your location': 'Explore su ubicación',
  'Facility that helps protect fish, maintain fish populations, and provide fun fishing opportunities.':
    'Instalacion que ayuda a proteger los peces, mantiene las poblaciones de peces y brinda oportunidades de pesca divertidas.',
  Filter: 'Filtrar',
  'Find places to Fish & Boat in your area': 'Encuentra lugares para Pescar y Navegar en tu Area',
  'First Name': 'Primer Nombre',
  'Fish Refuge or Hatchery': 'Refugios',
  'Fish Species': 'Especies de Peces',
  'Fishing Forecasts': 'Pronóstico de Pesca',
  'Fishing Restrictions': 'Restricciones de Pesca',
  'Fishing waters': 'Aguas de pesca',
  'Fly Fishing Shop': 'Tienda de Pesca con Mosca',
  'Follow the links below for troubleshooting': 'Siga estos enlaces para solucionar el problema',
  'For RBFF internal use only.': 'Para uso interno de RBFF.',
  'Gear and Equipment': 'Equipo de Pesca',
  'Get advanced hourly forecasts for every species on':
    'Obtén pronósticos por hora avanzados para cada especie en',
  'Get Directions': 'Obtén direcciones',
  'Get Licensed': 'Obtenga una Licencia',
  'Get a link to download the app': 'Obtén un enlace para descargar la aplicación',
  Good: 'Mejor',
  'Guide to map markers': 'Guía de marcadores en el mapa',
  Habitat: 'Habitat',
  'Hide full week': 'Ocultar semana completa',
  High: 'Alta',
  'How to Identify {}': 'Cómo Identificar {}',
  'It seems that Mapbox GL, which is required to run the map widget, is not supported in your browser. It could be that WebGL is disabled in your browser.':
    'Parece que Mapbox GL, el cual se requiere para ejecutar el mapa, no es compatible con su navegador. Podría ser que WebGL esté desactivado en su navegador.',
  Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec:
    'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.',
  January_February_March_April_May_June_July_August_September_October_November_December:
    'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre',
  'Join the Conversation': 'Únete a la Conversación',
  'Just now': 'Ahora',
  'Last Name': 'Apellido',
  'Latest Catches': 'Últimas Capturas',
  'Level of Government': 'Nivel de Gobierno',
  'License Vendor': 'Vendedor de Licencias',
  'Logged Catches': 'Capturas Registradas',
  'Looking to catch a specific species? Here are the available species in the area that have been caught by anglers on Fishbrain.':
    'Buscas capturar una especie específica? Aquí están las especies disponibles en esta área, capturadas por pescadores en Fishbrain.',
  Low: 'Baja',
  'Management Agency': 'Agencia de Gestion',
  'Map provided by': 'Mapa proporcionado por',
  Marina: 'Marina',
  'Marine Protected Area': 'Área Marina Protegida',
  'Moorings and supplies for yachts and small boats.':
    'Puerto pequeño con amarres y suministros para botes de pesca y otras embarcaciones.',
  'More Fishing License Info': 'Más información de Licencia de Pesca',
  'Multiple Marine Protected Areas': 'Múltiples Áreas Marina Protegida',
  'Multiple Places of Interest': 'Múltiples lugares de interés',
  'Multiple places that share the same location. Click on the marker to see the full list.':
    'Múltiples lugares que comparten la misma ubicación. Haga clic en el marcador para ver la lista completa.',
  Name: 'Nombre',
  'National Park': 'Parque Nacional',
  'Near {}': 'Cerca de {}',
  New: 'Nueva',
  'No matching locations for "{}".': 'No se encuentran ubicaciones para "{}".',
  'No species data in this area yet.': 'No hay datos de especies en esta área todavía.',
  'No weather forecasts are available at this time.':
    'Ningún pronóstico del clima está disponible en este momento.',
  'Not enough data for a fishing forecast in this area.':
    'No hay datos suficientes para un pronóstico de pesca en esta área.',
  'Not finding "{}"?': '¿No encuentra "{}"?',
  OK: 'Bueno',
  'Open email client with pre-filled information.':
    'Abra el correo electrónico con la información completada previamente.',
  'People often fish here for:': 'La gente frecuentemente pesca aquí por:',
  'Phone Number': 'Número de teléfono',
  'Phone:': 'Teléfono:',
  'Place to buy a fishing license.': 'Lugar donde puedes comprar una licencia de pesca.',
  'Place to buy all the fishing equipment you need for your fishing trip.':
    'Lugar para comprar todo el equipo de pesca que necesitas para tu paseo de pesca.',
  'Place to buy fishing bait and lures.': 'Lugar para comprar cebos y señuelos de pesca.',
  'Place to buy fly fishing equipment, fly fishing reels, rods and flies.':
    'Lugar para comprar equipo de pesca con mosca. Carretes de pesca con mosca, cañas y diferentes moscas.',
  'Place to go fish and boat.': 'Lugar para Pescar y Navegar',
  'Place to launch your boat into and out of the water.':
    'Lugar para desmontar o montar tu bote fuera o dentro del agua.',
  'Place to rent and charter boats.':
    'Lugar para alquilar botes de pesca u otro tipo de embarcaciones.',
  'Places to Fish & Boat Map': 'Mapa de Lugares para Pescar y Navegar',
  'Powered by': 'Proporcionado por',
  'Press "Explore your location" to start exploring your current area. You may be prompted to allow sharing of your location to use this feature.':
    'Presiona "Explore su ubicación" para comenzar a explorar tu área actual. Es posible que se le solicite que permita compartir su ubicación para usar esta función.',
  'Purchase a Fishing License': 'Compra una Licencia de Pesca',
  Region: 'Región',
  'Rules and Regulations': 'Reglas y Regulaciones',
  'Screenshots of the mobile application': 'Capturas de pantalla de la aplicación móvil',
  'Search locations...': 'Busca lugares...',
  'Search results': 'Resultados de búsqueda',
  'See local catches in the most popular fishing app in the world':
    'Vea capturas locales en la app de pesca más popular del mundo.',
  'See more catches on': 'Ver más capturas en',
  'See rules': 'Ver Reglas',
  Send: 'Enviar',
  'Show full week': 'Semana completa',
  Slow: 'Lento',
  'Species you can find in this area.': 'Especies que puedes encontrar en esta área',
  State: 'Estado',
  'Submit for review': 'Enviar para revisión',
  'Submitter Information': 'Información del remitente',
  'Suggest a Point of Interest': 'Sugerir un punto de interés',
  'Suggest an edit': 'Sugerir una edición',
  'Suggestion submitted!': 'Sugerencia enviada!',
  Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday:
    'domingo_lunes_martes_miércoles_jueves_viernes_sábado',
  'Take Me Fishing': 'Vamos A Pescar',
  'The Fishing Forecast tells you when certain species have an increased chance of striking. Predictions are based on real data of catches logged on Fishbrain.':
    'El pronóstico de pesca te dice cuándo ciertas especies tienen una mayor probabilidad de morder. Las predicciones se basan en datos reales de capturas registradas en Fishbrain.',
  'There are no catches logged here yet.': 'No hay capturas registradas aquí todavía',
  'These are selected national parks operated by the U.S. National Park Service that are good for either fishing, boating, or both.':
    'Estos son parques nacionales seleccionados operados por el Servicio de Parques Nacionales de EE. UU. Donde podras pescar, pasear en bote o ambos.',
  'These public waters are maintained by state or federal agencies to ensure healthy fish, state boat ramps, accessible recreational amenities and more.':
    'Estas aguas públicas son mantenidas por agencias estatales o federales para mantener peces saludables, rampas para botes, instalaciones recreativas y mucho más.',
  'This is a business': 'Esto es un negocio',
  Type: 'Tipo',
  'Uh-oh, something went wrong!': 'Oh, algo salió mal!',
  'Unknown Species': 'Especies desconocidas',
  'Validation failed': 'No valido ',
  'View all {} comments on Fishbrain': 'Ver todos {} los comentarios en Fishbrain',
  'View details on': 'Ver detalles en',
  'View what baits were used on': 'Ver qué carnada fue usada en',
  'We have sent you an SMS!': '¡Te hemos enviado un SMS!',
  Website: 'Sitio web',
  'Website:': 'Sitio web:',
  'With catches data from': 'Con capturas de datos de',
  'Year Established': 'Año Establecido',
  'You can personalize the map and display only the markers you are interested in by toggling them on and off.':
    'Puedes personalizar el mapa escogiendo los marcadores que te interesan a continuación.',
  'Zip Code': 'Código postal',
  'Zoom in to activate buttons': 'Ampliar para activar botones',
  'Zoom out to activate buttons': 'Alejar para activar botones',
  'Zoom in': 'Acercar enfoque',
  'Zoom out': 'Disminuir enfoque',
};
